module.exports = __webpack_public_path__ + "img/tipsbox.6278f268.png";